/* hh-v10-steps.js : Build Step by Step navigation. Process Arrows tabs + Next button inside the panel.
   Progressive enhancement over the stepper tabs (hh-stepper / hh-v4.js allSteps). Idempotent. */
(function () {
  'use strict';
  var sec, host, raf = 0, mo, busy = false;
  var NS = 'http://www.w3.org/2000/svg';
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function rm(n) { if (n && n.parentNode) n.parentNode.removeChild(n); }
  function reduced() { return !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches); }
  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) {} return null; }
  function svg(p) { return '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' + p + '</svg>'; }
  var IC = {
    cut: '<path d="M6 3l7.5 10M18 3l-7.5 10"/><circle cx="6.5" cy="17.5" r="3.5"/><circle cx="17.5" cy="17.5" r="3.5"/>',
    clean: '<path d="M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8z"/><path d="M18 16l.8 2.2L21 19l-2.2.8L18 22l-.8-2.2L15 19l2.2-.8z"/>',
    link: '<path d="M10 13a5 5 0 0 0 7.5.5l3-3a5 5 0 0 0-7-7l-1.7 1.7"/><path d="M14 11a5 5 0 0 0-7.5-.5l-3 3a5 5 0 0 0 7 7l1.7-1.7"/>',
    tracks: '<rect x="2.5" y="8" width="19" height="9" rx="4.5"/><path d="M7 8v9M11 8v9M15 8v9M19 8.6v7.8"/>',
    detail: '<path d="M14.7 6.3a4 4 0 0 0-5.4 5.2L3 17.8 6.2 21l6.3-6.3a4 4 0 0 0 5.2-5.4l-2.6 2.6-2.4-.6-.6-2.4z"/>',
    paint: '<rect x="7" y="9" width="8" height="12" rx="2"/><path d="M9 9V6h4v3M11 6V4h-1M17 5h.01M19.5 3.5h.01M19.5 7h.01M22 5h.01"/>',
    star: '<circle cx="12" cy="12" r="9"/><path d="M12 6.8l1.6 3.3 3.6.5-2.6 2.5.6 3.6-3.2-1.7-3.2 1.7.6-3.6-2.6-2.5 3.6-.5z"/>',
    drop: '<path d="M12 3s-5 5.6-5 9a5 5 0 0 0 10 0c0-3.4-5-9-5-9z"/><path d="M4 19h.01M20 18h.01M3 14h.01M21 13h.01"/>',
    display: '<rect x="4" y="4" width="16" height="12" rx="1.5"/><path d="M8 20h8M12 16v4"/>',
    sail: '<path d="M12 3v15M12 4l7 11H12M12 8L6 15h6M4 21h16"/>',
    plan: '<rect x="6" y="4" width="12" height="17" rx="2"/><path d="M9 4h6v3H9zM9 12h6M9 16h4"/>',
    leaf: '<path d="M5 19c0-8 5-14 14-14 0 9-6 14-14 14z"/><path d="M5 19l8-8"/>',
    layers: '<path d="M12 3l9 5-9 5-9-5z"/><path d="M3 13l9 5 9-5"/>',
    dome: '<path d="M3 17a9 9 0 0 1 18 0z"/><path d="M3 20h18"/>',
    dot: '<circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="3.5"/>'
  };
  function iconFor(name) {
    var n = name.toLowerCase();
    if (/weather|wash/.test(n)) return IC.drop;
    if (/display|pose|case/.test(n)) return IC.display;
    if (/decal|marking|flag/.test(n)) return IC.star;
    if (/rigging|mast/.test(n)) return IC.sail;
    if (/^plan/.test(n)) return IC.plan;
    if (/ground|vegetation|trees|ballast|cover/.test(n)) return IC.leaf;
    if (/track/.test(n)) return IC.tracks;
    if (/^cut/.test(n)) return IC.cut;
    if (/clean|prep|polish|seam|sand|fill|putty|smooth/.test(n)) return IC.clean;
    if (/support|sprue|trim/.test(n)) return IC.cut;
    if (/clear|top ?coat|varnish|gloss|seal/.test(n)) return IC.layers;
    if (/prime|paint|colou?r|base coat|shade|layer|camo|chrome/.test(n)) return IC.paint;
    if (/detail|photo|panel line|scribe|interior|fittings|figures|water|structures/.test(n)) return IC.detail;
    if (/assemble|glue|snap|hull|fuselage|keel|plank|superstructure|chassis|mount/.test(n)) return IC.link;
    if (/canopy|cockpit/.test(n)) return IC.dome;
    return IC.dot;
  }
  var TICK = '<svg viewBox="0 0 24 24" width="11" height="11" fill="none" stroke="currentColor" stroke-width="3.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.2 4.2L19 7"/></svg>';
  function tabName(t) {
    var l = $('.st-l', t); if (!l) return t.textContent.trim();
    var c = l.cloneNode(true); $$('.vh', c).forEach(rm);
    return c.textContent.replace(/\s+/g, ' ').trim();
  }
  function vis(e) { return !!(e && (e.offsetWidth || e.offsetHeight || e.getClientRects().length)); }
  // after switching hobby -> Everything the stepper leaves a hidden .st-bar next to the visible .v4-allbar: always work on the visible one
  function activeBar() { var bs = $$('.st-bar', sec), v = bs.filter(vis); return v.length ? v[v.length - 1] : bs[bs.length - 1]; }
  function barTabs() { var b = activeBar(); return b ? $$('.st-tabs .st-tab', b) : []; }
  function hobby() { var e = $('h2 em', sec); return e ? e.textContent.trim() : ''; }
  function modeKey() { return 'hhv10v:' + (document.documentElement.getAttribute('data-hh-mode') || 'x'); }
  function visitedSet() { var a = []; try { a = JSON.parse(ss(modeKey()) || '[]'); } catch (e) {} return a; }
  function curIndex(tabs) { var c = 0; tabs.forEach(function (t, i) { if (t.getAttribute('aria-selected') === 'true') c = i; }); return c; }
  function goNext(i) {
    var ts = barTabs();
    if (i < ts.length - 1) { ts[i + 1].click(); return; }
    var b = document.getElementById('bench');
    if (!b) return;
    var want = parseFloat(getComputedStyle(b).scrollMarginTop) || 0, tries = 0;
    b.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'start' });
    // content above the bench keeps growing (lazy cards/images) while the smooth scroll runs: re-aim until it settles
    (function settle() {
      setTimeout(function () {
        var d = b.getBoundingClientRect().top - want;
        if (Math.abs(d) > 24 && tries++ < 5) { b.scrollIntoView({ behavior: 'auto', block: 'start' }); settle(); }
      }, 700);
    })();
  }

  function ensureTop(bar) {
    var top = $('.v10-top', sec);
    if (!top) {
      top = document.createElement('div'); top.className = 'v10-top';
      top.innerHTML = '<p class="v10-hint" aria-hidden="true"><span class="v10-dot"></span>Click any step, or follow them in order</p><div class="v10-prog" aria-hidden="true"><span class="v10-pt"></span><span class="v10-bar"><i></i></span></div>';
      bar.parentNode.insertBefore(top, bar);
    } else if (top.nextElementSibling !== bar) bar.parentNode.insertBefore(top, bar);
    var all = $('.st-all', bar.parentNode) || $('.st-all', sec); var prog = $('.v10-prog', top);
    if (all && all.parentNode !== top) top.appendChild(all);
    return top;
  }

  function update() {
    raf = 0;
    sec = document.getElementById('build'); if (!sec) return;
    host = $('.steps-mode', sec);
    var bar = activeBar(), tabsEl = bar && $('.st-tabs', bar), tabs = bar ? $$('.st-tabs .st-tab', bar) : [];
    if (!host || !bar || !tabsEl || tabs.length < 2) return;
    busy = true; if (mo) mo.disconnect();
    try { run(bar, tabsEl, tabs); } catch (e) { if (window.console) console.warn('hh-v10', e); }
    busy = false; observe();
  }

  function run(bar, tabsEl, tabs) {
    $$('.v10-nextwrap', sec).forEach(rm);
    var n = tabs.length, cur = curIndex(tabs);
    var arts = $$('.step', host).filter(function (a) { return a.parentNode === host; });
    var verbs = tabs.map(function (t, i) { var a = arts[i], v = a && $('.step-verb', a); return v ? v.textContent.trim() : ''; });
    sec.classList.add('v10-on');
    tabsEl.classList.add('v10-tabs');
    // visited state
    var vis = visitedSet(); if (vis.indexOf(cur) < 0) { vis.push(cur); ss(modeKey(), JSON.stringify(vis)); }
    // top row
    var top = ensureTop(bar);
    var hintDone = ss('hhv10hint') === '1';
    top.classList.toggle('v10-nohint', hintDone || reduced() && false);
    var pt = $('.v10-pt', top), txt = 'Step ' + (cur + 1) + ' of ' + n; if (pt.textContent !== txt) pt.textContent = txt;
    $('.v10-bar i', top).style.width = ((cur + 1) / n * 100) + '%';
    // tabs
    tabs.forEach(function (t, i) {
      var name = tabName(t), sig = name + '|' + verbs[i] + '|' + i;
      var face = $(':scope > .v10-face', t);
      if (!face || t.getAttribute('data-v10sig') !== sig) {
        var l = $('.st-l', t);
        if (face) { $$('.v10-face,.v10-one,.v10-stt,.v10-bg', t).forEach(function (x) { if (x !== face && !x.contains(l)) rm(x); }); }
        if (!face) {
          face = document.createElement('span'); face.className = 'v10-face';
          face.innerHTML = '<span class="v10-bg" aria-hidden="true"></span><span class="v10-ic" aria-hidden="true"></span><span class="v10-tx"><span class="v10-no" aria-hidden="true"></span></span>';
          t.insertBefore(face, t.firstChild);
          if (l) $('.v10-tx', face).appendChild(l);
          var one = document.createElement('span'); one.className = 'v10-one'; one.setAttribute('aria-hidden', 'true');
          t.appendChild(one);
          var stt = document.createElement('span'); stt.className = 'vh v10-stt'; l && l.appendChild(stt);
        }
        $('.v10-ic', face).innerHTML = svg(iconFor(name)) + '<span class="v10-tick">' + TICK + '</span>';
        $('.v10-no', face).textContent = 'Step ' + (i + 1);
        $('.v10-one', t).textContent = verbs[i];
        t.setAttribute('data-v10sig', sig);
      }
      var st = i === cur ? 'on' : (vis.indexOf(i) >= 0 ? 'done' : 'todo');
      if (t.getAttribute('data-v10') !== st) t.setAttribute('data-v10', st);
      var stt2 = $('.v10-stt', t), sv = st === 'on' ? ', current step' : (st === 'done' ? ', visited' : '');
      if (stt2 && stt2.textContent !== sv) stt2.textContent = sv;
    });
    // mobile one-liner + notch
    var mone = $('.v10-mone', bar);
    if (!mone) { mone = document.createElement('p'); mone.className = 'v10-mone'; mone.setAttribute('aria-hidden', 'true'); bar.appendChild(mone); }
    var mt = 'Step ' + (cur + 1) + ': ' + verbs[cur]; if (mone.textContent !== mt) mone.textContent = mt;
    var notch = $('.v10-notch', bar);
    if (!notch) { notch = document.createElement('i'); notch.className = 'v10-notch'; notch.setAttribute('aria-hidden', 'true'); bar.appendChild(notch); }
    var act = tabs[cur], br = bar.getBoundingClientRect(), ar = act.getBoundingClientRect();
    var nx = Math.round(ar.left - br.left + Math.min(ar.width, 190) / 2 + 4);
    notch.style.left = nx + 'px';
    // auto-centre
    if (tabsEl.scrollWidth > tabsEl.clientWidth + 4) {
      var target = act.offsetLeft - (tabsEl.clientWidth - act.offsetWidth) / 2;
      if (Math.abs(tabsEl.scrollLeft - target) > 4 && lastCur !== cur) tabsEl.scrollTo({ left: Math.max(0, target), behavior: reduced() || lastCur === null ? 'auto' : 'smooth' });
    }
    lastCur = cur;
    // fade cue
    bar.classList.toggle('v10-more', tabsEl.scrollWidth > tabsEl.clientWidth + 4 && tabsEl.scrollLeft + tabsEl.clientWidth < tabsEl.scrollWidth - 6);
    // next buttons inside each panel
    var h = hobby(), all = !h || sec.hasAttribute('data-v4all');
    arts.forEach(function (a, i) {
      var shop = $('.st-shop', a); if (!shop) return;
      var row = $(':scope > .v10-nextrow', shop), btn;
      if (!row) {
        row = document.createElement('div'); row.className = 'v10-nextrow';
        btn = document.createElement('button'); btn.type = 'button'; btn.className = 'v10-next';
        btn.innerHTML = '<span class="v10-lbl"></span><span class="v10-arr" aria-hidden="true">→</span>';
        btn.addEventListener('click', function () { goNext(+btn.getAttribute('data-i')); });
        row.appendChild(btn); shop.insertBefore(row, shop.firstChild);
      }
      btn = $('.v10-next', row);
      var last = i === n - 1;
      var label = last ? (all ? 'See the starter kits' : 'See your ' + h + ' kits') : 'Next: ' + tabName(tabs[i + 1]);
      var s = $('.v10-lbl', btn); if (s.textContent !== label) s.textContent = label;
      btn.setAttribute('data-i', i);
      var aria = last ? label : 'Next step: ' + tabName(tabs[i + 1]);
      if (btn.getAttribute('aria-label') !== aria) btn.setAttribute('aria-label', aria);
    });
    bindOnce(bar, tabsEl);
  }
  var lastCur = null, bound = new WeakSet();
  function bindOnce(bar, tabsEl) {
    if (!bound.has(tabsEl)) {
      bound.add(tabsEl);
      tabsEl.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.st-tab')) ss('hhv10hint', '1'); var t = $('.v10-top', sec); if (t) t.classList.add('v10-nohint'); }, true);
      tabsEl.addEventListener('keydown', function (e) {
        var ts = $$('.st-tab', tabsEl), c = curIndex(ts), k = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') k = c + 1; else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') k = c - 1;
        else if (e.key === 'Home') k = 0; else if (e.key === 'End') k = ts.length - 1;
        if (k === null) return;
        e.preventDefault(); e.stopPropagation();
        k = Math.max(0, Math.min(ts.length - 1, k));
        if (k !== c) ts[k].click();
        var again = $$('.st-tab', tabsEl)[k]; if (again) again.focus();
      }, true);
    }
    if (host && !bound.has(host)) {
      bound.add(host);
      var x0 = null, y0 = 0;
      host.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
      host.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0; x0 = null;
        if (Math.abs(dx) > 70 && Math.abs(dx) > 2 * Math.abs(dy)) {
          var ts = barTabs(), c = curIndex(ts), k = c + (dx < 0 ? 1 : -1);
          if (k >= 0 && k < ts.length) ts[k].click();
        }
      }, { passive: true });
    }
  }
  function sched() { if (busy) return; if (!raf) raf = requestAnimationFrame(update); }
  function observe() {
    if (!sec) return;
    try { if (!mo) mo = new MutationObserver(sched); mo.observe(sec, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-selected', 'data-v4all'] }); } catch (e) {}
  }
  function init() {
    sec = document.getElementById('build'); if (!sec) return;
    update(); observe();
    window.addEventListener('resize', sched, { passive: true });
    var t = $('.st-tabs', sec); // scroll cue refresh
    document.addEventListener('scroll', function () {}, { passive: true });
    sec.addEventListener('scroll', sched, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
